import { createStructuredSelector } from 'reselect';

const selectSurveyTemplates = state => state.surveyTemplates;
const surveyTemplateListSelector = createStructuredSelector({
  surveyTemplates: selectSurveyTemplates
});

export { surveyTemplateListSelector };
